/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2016] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backgrid from 'backgrid';
import PSASelectRowCell from 'psa-backgrid/SelectRowCell';

const SelectRowCell = PSASelectRowCell.SelectRowCell.extend({
  render() {
    PSASelectRowCell.SelectRowCell.prototype.render.call(this);
    this.checkbox().attr('aria-label', 'Select');
    if(this.model.get('asset')) this.checkbox().addClass(this.model.get('asset'))
    return this;
  }
});

const SelectAllHeaderCell = PSASelectRowCell.SelectAllHeaderCell.extend({
  render() {
    PSASelectRowCell.SelectAllHeaderCell.prototype.render.call(this);
    this.checkbox().attr('aria-label', 'Select');
    return this;
  }
});

Backgrid.Extension.SelectRowCell = SelectRowCell;
Backgrid.Extension.SelectAllHeaderCell = SelectAllHeaderCell;

export default {
  SelectRowCell,
  SelectAllHeaderCell
};
